import { render, staticRenderFns } from "./DeviceTactics.vue?vue&type=template&id=2691288a&scoped=true&"
import script from "./DeviceTactics.vue?vue&type=script&lang=js&"
export * from "./DeviceTactics.vue?vue&type=script&lang=js&"
import style0 from "./DeviceTactics.vue?vue&type=style&index=0&id=2691288a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2691288a",
  null
  
)

export default component.exports